var Exception = function (message) {
    this.name = this.constructor.name;
    this.message = message;
    Error.call(this, message);
    if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }
    else {
        this.stack = (new Error()).stack;
    }
};
Exception.prototype = Object.create(Error.prototype);
export default Exception;
//# sourceMappingURL=Exception.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/exceptions/Exception.js
// module id = 9
// module chunks = 1